/**
 * Route Constants
 * 
 * Centralized route paths to prevent typos and improve maintainability
 */

export const ROUTES = {
  HOME: '/',
  MOVIES: '/',
  TV: '/tv',
  CINEMA: '/cinema',
  MOVIE_DETAIL: '/movie/:id',
  TV_DETAIL: '/tv/:id',
  SEARCH: '/search',
  COLLECTIONS: '/collections',
  FAVORITES: '/favorites',
  WATCHLIST: '/watchlist',
  WATCHED: '/watched',
  VERIFY_EMAIL: '/verify-email',
  CONTACT: '/kontaktai',
};

// Helper to build route with params
export function buildRoute(route, params = {}) {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
}

// Route helpers
export const RouteHelpers = {
  movieDetail: (id) => `/movie/${id}`,
  tvDetail: (id) => `/tv/${id}`,
  search: (query) => `/search?q=${encodeURIComponent(query)}`,
};
